export default __webpack_public_path__ + "static/media/card-discover.06ded89e.svg";